import styled from "styled-components";
import { IStyledContextMenuMain } from "./model";

export const ContextMenuMain = styled.div<IStyledContextMenuMain>`
  position: absolute;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  width: auto;
  height: auto;
  border-radius: 5px;
  box-sizing: border-box;
  z-index: 1000;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow: hidden;
`;

export const ContextMenuContainer = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`;

export const ContextMenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  cursor: pointer;

  i {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 8px;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }
`;
